/* eslint-disable react/no-string-refs */
import { h, Component } from 'preact';
import style from './style';
import cx from 'classnames';
import linkRef from 'linkref';

// Based on https://github.com/react-bootstrap/react-bootstrap/blob/master/src/SafeAnchor.js

function isTrivialHref(href) {
	return !href || href.trim() === '#';
}

export default class SafeAnchor extends Component {
	static defaultProps = {
		componentClass: 'a'
	}

	focus = () => {
		const { inner } = this.refs;
		if (typeof inner !== 'undefined' && typeof inner.focus === 'function') {
			inner.focus();
		}
	}

	handleClick = (e) => {
		const { disabled, onClick } = this.props;

		if (disabled) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		if (onClick) {
			onClick(e);
		}
	}

	render({ disabled, componentClass: ComponentClass, ...props }) {
		if (isTrivialHref(props.href)) {
			ComponentClass = 'button';
			delete props.href;
		}

		if (disabled) {
			props.tabindex = '-1';
			props.class = cx(props.class, style.noPointerEvents);
		}

		return (
			<ComponentClass
				{...props}
				ref={linkRef(this, 'inner')}
				onClick={this.handleClick}
			/>
		);
	}
}
